/* eslint-disable @typescript-eslint/no-explicit-any */
import { AspectRatio } from "@/components/ui/aspect-ratio";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { PlaceholderImage } from "@/components/common/placeholder-image";

export default function MobileCard(props: any) {
  const { isSelected, image_link, name, title, description, year } = props;

  return (
    <div className="relative w-full transition-all duration-300">
      <AspectRatio
        ratio={isSelected ? 84 / 71 : 100 / 71}
        className={cn("relative overflow-hidden bg-[#663B84] transition-all duration-500", {
          "rounded-2xl shadow-2xl": isSelected,
          "rounded-[16px]": !isSelected,
        })}
      >
        {image_link ? (
          <Image
            src={image_link}
            fill
            className={cn("object-cover transition-all duration-500", {
              "scale-105 opacity-100 mix-blend-normal": isSelected,
              "opacity-60 mix-blend-luminosity": !isSelected,
            })}
            alt={name}
            sizes="(max-width: 1024px) 100vw, 400px"
          />
        ) : (
          <PlaceholderImage />
        )}
      </AspectRatio>

      {/* Details Container - Only visible/rendered when selected or with a transition */}
      <div
        className={cn(
          "absolute left-0 w-full pt-10 transition-all duration-500",
          isSelected ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        )}
      >
        <h1 className="text-4xl tracking-[-1.44px] text-secondary 2xl:text-6xl ltr:font-playfair">
          {name}
        </h1>
        <p className="py-2 text-xl text-[#FFCC68] ltr:font-sans">{`${title} - ${year}`}</p>
        <p className="max-w-sm pt-4 text-base leading-[24px] text-secondary/60 2xl:max-w-md 2xl:pt-8 2xl:text-xl 2xl:leading-[32px]">
          {description}
        </p>
      </div>
    </div>
  );
}
